<template>
  <b-card title="Roles">
    <b-overlay :show="loadingData" variant="transparent" no-wrap />

    <!-- modal permissions-->
    <b-modal
      id="modal-permissions"
      centered
      hide-footer
      size="xl"
      :title="`role permissions: ${roleData.name}`">
      <permissions :roleData="roleData"/>
    </b-modal>

    <!-- modal edit-->
    <b-modal
      ref="modal-update"
      id="modal-role"
      centered
      hide-footer
      size="xl"
      :title="`role: ${formData.name}`">
      <b-form @submit.prevent="updateForm">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required">
                <b-form-input
                  v-model="formData.name"
                  :state="errors.length > 0 ? false:null"
                  placeholder="name"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="description"
                rules="required">
                <b-form-input
                  v-model="formData.description"
                  :state="errors.length > 0 ? false:null"
                  placeholder="description"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <h2>permissions</h2>

              <div v-for="(item, index) in formData.permissions" :key="index">
                <br>
                 <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required">
                    <b-form-input
                      v-model="item.name"
                      :state="errors.length > 0 ? false:null"
                      placeholder="name"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group >
                  <validation-provider
                    #default="{ errors }"
                    name="slug"
                    rules="required">
                    <b-form-input
                      v-model="item.slug"
                      :state="errors.length > 0 ? false:null"
                      placeholder="slug"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  @click="removePermission(index)"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  class="btn-icon">
                  <feather-icon icon="TrashIcon" />
                </b-button>

              </div>
            <br>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="addPermission">
              add
            </b-button>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit">
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
          <b-button
            class="text-nowrap ml-2"
            variant="primary"
            @click="$refs.addUpdateRole.modalShow = true"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap">Add</span>
          </b-button>
          <add-update-roles  ref="addUpdateRole" />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm 
        }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }
      ">

      <template slot="table-row" slot-scope="props">

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <b-dropdown-item 
                @click="formData = props.row"
                v-b-modal.modal-role      
                v-ripple.400="'rgba(255, 255, 255, 0.15)'">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>

              <b-dropdown-item
              @click="deleteRole(props.row._id)">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-if="props.column.field == 'permissions'">
            <b-button
            @click="roleData = props.row"
            v-b-modal.modal-permissions      
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success">
            See all permissions
          </b-button>
        </span>

        <!-- Column: Common -->
        <span v-else>
         {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10','15','20']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton, VBModal, BForm, BRow, BCol, BOverlay, BCard
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions  } from 'vuex'
import Ripple from 'vue-ripple-directive'
import Permissions from './Permission'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer } from '@validations'
import AddUpdateRoles from './addUpdateRoles.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    VBModal,
    Permissions,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BOverlay,
    BCard,
    AddUpdateRoles,
    ToastificationContent
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      roleData: {
        name: null,
        permissions: []
      },
      formData: {
        name: null,
        description: null,
        permissions: []
      },
      columns: [
        {
          label: 'name',
          field: 'name',
        },
        {
          label: 'description',
          field: 'description',
        },
        {
          label: 'permissions',
          field: 'permissions',
        },
        {
          label: 'action',
          field: 'action',
        }
      ],
      searchTerm: '',
      required,
      loadingData: false
    }
  },
  computed: {
    rows() {
      return this.$store.state.role.roles;
    },
  },
  created() {
    this.getRoles()
  },
  methods: {
    ...mapActions('role', ['roles', 'destroy', 'update']),
    async getRoles() {
      try {
        this.loadingData = true;
        await this.$store.dispatch("role/roles");
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching roles list",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      } finally {
        this.loadingData = false;
      }
    },
    async deleteRole(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(async result => {
        if (result.value) {
          let response = await this.destroy(id)
          if(response){
            this.getRoles()
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              text: response.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        }
      })
    },
    mapPermissions(permissions){
      return permissions.map(e => e.name).join(', ')
    },
    addPermission() {
      this.formData.permissions.push({
        name: null,
        slug: null
      })
    },
    removePermission(index){
      this.formData.permissions.splice(index, 1);
    },
    async updateForm() {
      let response = await this.update(this.formData)
      if(response){
        this.$refs['modal-update'].hide()
        this.formData = {}
        this.$swal({
          title: 'Update Currency',
          text: response.message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
  }
}
</script>

<style lang="scss" >
.vgt-responsive{
    overflow-x: inherit !important;
}
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>